<template>
    <div class="ma-2">
        <!--         <TablaConLista></TablaConLista> -->
    </div>

</template>

<script>
/* import TablaConLista from '@/components/grids/TablaConLista.vue'; */
export default {
    components: {
        /*         TablaConLista */
    },
    data() {
        return {

        }
    }
}
</script>